// import GeoMoverDB from '@/db/indexeddb'

export default {
  setAllMapHosts ({ commit }, payload) {
    commit('SET_ALL_MAP_HOSTS', payload)
  },
  setCurrentMapHost ({ dispatch, commit }, payload) {
    // Save the map host id in the store
    commit('SET_CURRENT_MAP_HOST', payload)
    dispatch('settings/updateOneSetting', {
      feature: 'currentMapHost',
      value: payload
    }, { root: true })
  },
  setCurrentMapHostObj ({ commit }, payload) {
    // Save the complete map host obj ONLY in the store (not to IDB)
    commit('SET_CURRENT_MAP_HOST_OBJ', payload)
  }
}
